import { CellDate } from 'components/common';

import { Flex, Icon, Tooltip, Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';
import { DeltaEta, Nullable } from '@project44-models/shipment-list';

import { getMetadata } from './utils';

interface ICellDateEstimate {
  estimatedDateTime?: Nullable<string>;
  actualDateTime?: Nullable<string>;
  deltaEstimatedTime?: Nullable<DeltaEta>;
}

function CellDateEstimate({
  estimatedDateTime,
  deltaEstimatedTime,
  actualDateTime,
}: ICellDateEstimate) {
  const { t } = useTranslation();
  const hasDate = !!(actualDateTime || estimatedDateTime) && deltaEstimatedTime;
  const isEstimate = !!estimatedDateTime && !actualDateTime;
  const { title, description, color, msg } = getMetadata(
    deltaEstimatedTime,
    isEstimate,
  );

  const items = msg.map(([value, unit]) => t(unit, { count: value }));
  const header = title ? t(title, { message: items[0] }) : '';
  const label = description ? t(description, { time: items.join(' ') }) : '';

  return (
    <Tooltip title={label} isDisabled={!deltaEstimatedTime}>
      <Flex align="center" gap="small">
        <Icon
          icon="auto_awesome"
          css={{
            color: '$palette-purple-700',
            fontSize: '$medium',
            opacity: isEstimate ? 1 : 0,
          }}
        />
        <Flex
          data-testid="estimated-deliver-date"
          align="center"
          gap="small"
          css={{
            borderRadius: '$small',
            backgroundColor: isEstimate ? '$palette-purple-50' : '',
            padding: isEstimate ? '$x-small $small' : '',
          }}
        >
          <CellDate dateTime={actualDateTime || estimatedDateTime} />
          {hasDate && (
            <Typography variant="subtextBold" css={{ color }}>
              {header}
            </Typography>
          )}
        </Flex>
      </Flex>
    </Tooltip>
  );
}

export default CellDateEstimate;
